import _ from 'underscore';
import { CampaignSelectorView } from '@bingads-webui-campaign-react/campaign-selector';
import { getCampaignData } from './campaign-selector-repository';

const PAGESIZE = 10;

export class CampaignSelectorProxy {
  constructor({
    onEventTrigger,
    getCustomizedData,
    jsData,
    edmCampaign,
    withUiBlocker,
    i18n,
    selectedItem,
    optionalCampaignFilter,
    optionalCampaignSelect,
    isMultiMode,
    onSelectDone,
  } = {}) {
    this.onEventTrigger = onEventTrigger;
    this.getCustomizedData = getCustomizedData || null;
    this.jsData = jsData;
    this.edmCampaign = edmCampaign;
    this.withUiBlocker = withUiBlocker;
    this.i18n = i18n;
    this.selectedItem = selectedItem;
    this.optionalCampaignFilter = optionalCampaignFilter;
    this.optionalCampaignSelect = optionalCampaignSelect;
    this.isMultiMode = isMultiMode;
    this.onSelectDone = onSelectDone;
  }

  fecthCampaignData({
    query,
    pageNumber,
    pageSize,
    campaignSelectorView,
    optionalCampaignFilter = this.optionalCampaignFilter,
  }) {
    const uiBlockContainer = campaignSelectorView && campaignSelectorView.$el && campaignSelectorView.$el.find('.dropdown-menu');

    if (this.getCustomizedData === null) {
      return getCampaignData({
        query,
        pageNumber,
        pageSize,
        optionalCampaignFilter,
        optionalCampaignSelect: this.optionalCampaignSelect,
      }, this.jsData).finally(this.withUiBlocker(uiBlockContainer));
    }

    return this.getCustomizedData({
      query,
      pageNumber,
      pageSize,
    }, this.jsData).finally(this.withUiBlocker(uiBlockContainer));
  }

  getCampaignSelectorView() {
    const checkSelected = (selectedItem, item) => selectedItem && selectedItem.Id === item.Id;
    const campaignSelectorView = new CampaignSelectorView({
      i18n: this.i18n,
      fetch: ({ query = '', pageNumber = 0 }) => this.fecthCampaignData({
        query,
        pageNumber,
        pageSize: PAGESIZE,
        campaignSelectorView,
      }),
      pageSize: PAGESIZE,
      selectedItem: this.selectedItem,
      checkSelected,
      isMultiMode: this.isMultiMode,
      onSelectDone: this.onSelectDone,
    });

    campaignSelectorView.on('selected-campaign', (selectedItem) => {
      if (_.isFunction(this.onEventTrigger)) {
        this.onEventTrigger(selectedItem);
      }
    });

    return campaignSelectorView;
  }
}
